import { Cohort, EduType, LegalAgeGroupClassification, Persona, } from '@office-start/metaos-hub-sdk';
export const getAgeGroup = (ageGroup) => {
    switch (ageGroup) {
        case 'None':
            return null;
        case 'Adult':
            return LegalAgeGroupClassification.Adult;
        case 'MinorNoParentalConsentRequired':
            return LegalAgeGroupClassification.MinorNoParentalConsentRequired;
        case 'MinorWithOutParentalConsent':
            return LegalAgeGroupClassification.MinorWithoutParentalConsent;
        case 'MinorWithParentalConsent':
            return LegalAgeGroupClassification.MinorWithParentalConsent;
        case 'NotAdult':
            return LegalAgeGroupClassification.NonAdult;
        default:
            return null;
    }
};
export const getCohort = (cohort) => {
    switch (cohort) {
        case 'BCAIS':
            return Cohort.BCAIS;
        case 'BCWAF':
            return Cohort.BCWAF;
        case 'BCWBF':
            return Cohort.BCWBF;
        case 'None':
            return Cohort.None;
        default:
            return null;
    }
};
export const getUserClassification = (eduType, persona) => {
    if (persona === 'None') {
        return { persona: Persona.Other };
    }
    if (persona === 'Faculty' || persona === 'Student') {
        const personaType = persona === 'Faculty' ? Persona.Faculty : Persona.Student;
        switch (eduType) {
            case 'Hed':
                return {
                    eduType: EduType.HigherEducation,
                    persona: personaType,
                };
            case 'K12':
                return {
                    eduType: EduType.K12,
                    persona: personaType,
                };
            case 'Others':
                return {
                    eduType: EduType.Other,
                    persona: personaType,
                };
            default:
                return null;
        }
    }
    return null;
};
//# sourceMappingURL=eligibilityUtility.js.map